import React, { useState, useEffect, useRef } from 'react';

import {BrowserRouter as Router, Routes,Route} from 'react-router-dom'
import { Link,useNavigate,useLocation } from 'react-router-dom';
import axios from 'axios'; 
import useAuth from '../hooks/useAuth';
// Config
import {
Register_URL
}from '../config'
// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';
import Display from './Display';

// Hook

// Image




const Register = () => {
  const {setAuth} = useAuth();
  
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  
  const emailref = useRef()
  const userRef = useRef();
  const errRef = useRef();
  
  const [formData, setFormData] = useState({username: '',email: '', password: ''});
  const [errMessage,setErrMessage] = useState("");
  const [success, setSuccess]= useState(false);
  const [response,setResponse]= useState(false)
  const [responseMessage,setResponseMessage] = useState("");
  
  useEffect(()=>{
    userRef.current.focus()
  },[])

  useEffect(()=>{
    setErrMessage('')
  },[formData])



  const onSubmit = async (e) => {
      e.preventDefault()
      console.log(formData)

      if(!formData.email){
        emailref.current.focus()
        return setErrMessage("No email!")
      }if(!formData.username){
        return setErrMessage("No username!")
      }if(!formData.password){
        return setErrMessage("No password!")
      }


      try {
        const response =  await axios.post(`${Register_URL}`,
          JSON.stringify(formData),
          {
            headers: {'Content-Type': 'application/json'}
           
          }
        );


        console.log(response)

      if(!response.status===200){
        throw new Error("Failed to fetch as ther is no Response");
      }else{
        setResponse(true)
        setResponseMessage(response?.data.message)
      }  


      const accessToken = response?.data?.accessToken
      const user = response?.data?.user
        console.log(JSON.stringify(response?.data))

        setAuth({formData,accessToken,user})
        
        // navigate(from, {replace: true});

      } catch (error) {

        if(!error.response){
          console.log(Register_URL)
          setErrMessage("No server response")
        }else if (error.response?.status === 400){
          setErrMessage("Missing username or password")
        } else {
          setErrMessage('Register failed')
        }
        console.log(error)
      }
        
          
  }

  return (
    <>
    <Header Login={true}></Header>
    <section className='error'>

      <p ref={errRef}>
      {errMessage}
      </p>

      {response?<div>{responseMessage}</div>:""}
    </section>

    
    

      <form  onSubmit={onSubmit} className="FormClass">
      <h1>Register an account:</h1>
      <label>Email</label>
          <input ref = {emailref} type={"email"} onChange={(e)=>setFormData({...formData, email: e.target.value})}/>
          <label>Username</label> 
            <input ref={userRef} type={"text"} onChange={(e)=>setFormData({...formData, username: e.target.value})}/>
            <label>Password</label>
          <input type={"password"} autoComplete='off' onChange={(e)=>setFormData({...formData, password: e.target.value})}/>

          <button>Submit</button>
      </form>
      <Knoppie
        callback={() => setFormData({ username: '', email: '', password: '' })}
        text={"Back to Login?"}
        destination={"/login"}
        clickable={true}
        >

      </Knoppie>
      
      </>
  )
};

export default Register;
